import { useCallback, useState } from 'react';

/**
 * 선택 상태를 localStorage 에 기억한다.
 *
 * 주간회의는 담당 부서·현장이 정해져 있어서, 들어올 때마다 첫 항목으로 돌아가면 매번 다시 골라야 한다.
 * v1이 화면마다 손으로 하던 일(`localStorage.getItem` + `useEffect` 로 저장)을 한 곳에 모았다.
 *
 * 저장된 값이 아직 유효한지(그 주차·현장이 남아 있는지)는 저장소가 알 수 없다.
 * 그래서 읽기만 하고, **유효성 판단은 화면이 목록을 손에 쥔 뒤에 한다**.
 */
export function useStoredState(storageKey: string): [string | null, (value: string | null) => void] {
  const [value, setValue] = useState<string | null>(() => readStored(storageKey));

  const update = useCallback(
    (next: string | null) => {
      setValue(next);
      if (next === null) window.localStorage.removeItem(storageKey);
      else window.localStorage.setItem(storageKey, next);
    },
    [storageKey],
  );

  return [value, update];
}

function readStored(storageKey: string): string | null {
  try {
    return window.localStorage.getItem(storageKey);
  } catch {
    // 사생활 보호 모드 등에서 접근이 막힐 수 있다. 기억을 못 할 뿐이므로 화면은 그대로 뜬다.
    return null;
  }
}
